import ChangePassword from '@/assets/icons/ChangePassword.svg';
import styled from 'styled-components';

export const StyledChangePassword = styled(ChangePassword)`
  path {
    fill: ${({ theme }) => theme.colorTextBase};
  }
`;
